import React, { useContext, useState } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { GameContext } from "../GameContext";
import { RoundManager } from "./RoundManager";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: {
    opacity: 0,
    y: 100
  },
  visible: {
    opacity: 1,
    y: 0
  },
  exit: {
    scale: 0,
    transition: {
      ease: "backOut",
      duration: 0.35
    }
  }
};

export const Game = ({ gameData }: { gameData: any }) => {
  const game = useContext(GameContext);
  const history = useHistory();
  const roundIndex = game.roundEndTimes.findIndex(r => r > moment());
  const currentRound = roundIndex + 1;
  const [hasPushed, setHasPushed] = useState(false);

  if (roundIndex < 0 && !hasPushed) {
    setHasPushed(true);
    history.push(`/result/${game.id}`);
    return <div>Game has ended.</div>;
  }

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <RoundManager
        currentRound={currentRound}
        gameData={gameData}
      ></RoundManager>
    </motion.div>
  );
};
